<div class="ion-padding">
  <button ion-button class="big-text-btn" routerLink="feedbackseekhelpif" expand="block" color="primary">{{labels('Symptom Checker')}}</button>
</div>